import { CompanyProfile } from 'models';

type ServicesInfo = NonNullable<CompanyProfile['servicesInfo']>[0];

export const ServicesInfoHelpers = {
    getCompletenessScore: (service: ServicesInfo) => {
        let score = 0;

        if (service.description) score += 10 + Math.ceil(service.description.length / 100);
        if (service.image) score += 20;

        if (service.capabilities?.length) score += service.capabilities.length * 3;
        if (service.keyDifferentiators?.length) score += service.keyDifferentiators.length * 2;
        if (service.tags?.length) score += Math.ceil(service.tags.length / 2);

        return score;
    },
};
